export default __webpack_public_path__ + "static/media/phone.f362f7ff.png";